import { c as _c } from "react/compiler-runtime";
interface SearchIconProps {
  className?: string;
}
export const CloseIcon = t0 => {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <rect x="3.25195" y="20.2002" width="28" height="2.4" transform="rotate(-45 3.25195 20.2002)" fill="currentColor" />;
    t2 = <rect x="4.94922" y="0.200195" width="28" height="2.4" transform="rotate(45 4.94922 0.200195)" fill="currentColor" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};